import { Tilleggsdata } from './../../../models/tilleggsdata';
import { getQueryURL } from '../requestService';
import { client } from '../../client';
import { FilterQueries } from '../../../app/utils/filter';
import { MessageRequiredAnswer } from '../../../models/messageRequiredAnswer';
import RequestTreeService from '../requestTreeService';
import { TilleggsdataLight } from '../../../models/tilleggsdataLight';

export default class TilleggsdataService extends RequestTreeService<Tilleggsdata, 'tilleggsdata'> {
    tilleggsdataErIBruk = async (id: number) =>
        client.get<boolean>
            (getQueryURL(`${this.serviceName}/${encodeURIComponent(id)}/tilleggsdata_er_bruk`));

    tilleggsdataVerdiErIBruk = async (id: number, verdiId: number) =>
        client.get<boolean>
            (getQueryURL(`${this.serviceName}/${id}/${verdiId}/tilleggsdataVerdi_er_bruk`, { id, verdiId }));

    hentTilleggsdataLightListe =
        async (searchString: string) =>
            client.get<TilleggsdataLight[]>
                (`${this.serviceName}/hentTilleggsdataLightListe?q=${encodeURIComponent(searchString)}`);

    getRootForChild = async (id: number) => client.get<Tilleggsdata>(`${this.serviceName}/${encodeURIComponent(id)}/root`);
    xmlRegisterEksport = async (taMedUnderElementer: boolean, filter?: FilterQueries) => client.getFile(`${this.serviceName}/xml-register-eksport?taMedUnderElementer=${encodeURIComponent(taMedUnderElementer)}`, 'POST', filter ?? { parameters: undefined });
    xmlEksport = async (id: number, taMedUnderElementer: boolean) => client.getFile(`${this.serviceName}/${encodeURIComponent(id)}/xml-eksport?taMedUnderElementer=${encodeURIComponent(taMedUnderElementer)}`, 'GET');
    xmlFlytInnstillingerEksport = async (id: number, taMedUnderElementer: boolean) => client.getFile(`${this.serviceName}/${encodeURIComponent(id)}/xml-eksport/flytinnstillinger?taMedUnderElementer=${encodeURIComponent(taMedUnderElementer)}`, 'GET');
    slettFlytInnstillinger = async (id: number) => client.delete<void>(`${this.serviceName}/${encodeURIComponent(id)}/slett_flytinnstillinger`);
    importFromXML = async (fileContent: Blob, filNavn: string) => {
        try {
            const buffer = await fileContent.arrayBuffer();
            const res = await client.post<MessageRequiredAnswer>(getQueryURL(`${this.serviceName}/import`, { filNavn }), buffer);
            return { success: true, msg: res.message };
        } catch (err) {
            return { success: false, msg: (err as Error).message };
        }
    };
    importFlytInnstillingerFromXML = async (tilleggsdataId: number, fileContent: Blob, filNavn: string) => {
        try {
            const buffer = await fileContent.arrayBuffer();
            const res = await client.post<MessageRequiredAnswer>(getQueryURL(`${this.serviceName}/${encodeURIComponent(tilleggsdataId)}/import_flytinnstillinger`, { filNavn }), buffer);
            return { success: true, msg: res.message };
        } catch (err) {
            return { success: false, msg: (err as Error).message };
        }
    };
}
